<template>
    <!-- Meta Tags -->
    <Head :title="`${product.name}`" />

    <section
        class="bg-[#061991] w-full min-h-screenheaderfooter flex flex-col justify-center items-center bg-heart-orange-mobile md:bg-heart-orange bg-top bg-cover md:bg-bottom bg-no-repeat"
    >
        <div class="container py-8 md:py-12">
            <nav class="flex mb-8" aria-label="Breadcrumb">
                <ol class="inline-flex items-center space-x-1 md:space-x-2">
                    <li class="inline-flex items-center">
                        <Link
                            href="/"
                            class="inline-flex items-center text-sm font-medium text-white hover:text-orange hover:underline"
                        >
                            <svg
                                aria-hidden="true"
                                class="w-4 h-4 mr-2"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                                ></path>
                            </svg>
                            Inicio
                        </Link>
                    </li>
                    <li class="inline-flex items-center">
                        <Link
                            href="/productos"
                            class="inline-flex items-center text-sm font-medium text-white hover:text-orange hover:underline"
                        >
                            <svg
                                aria-hidden="true"
                                class="w-6 h-6 text-white"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                            Productos
                        </Link>
                    </li>
                    <li aria-current="page">
                        <div class="flex items-center">
                            <svg
                                aria-hidden="true"
                                class="w-6 h-6 text-white"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                            <span class="ml-1 text-sm font-bold md:ml-2">{{ product.name }}</span>
                        </div>
                    </li>
                </ol>
            </nav>

            <div class="md:flex justify-center items-start md:gap-16" id="main-content">
                <div class="w-full mb-4 md:w-1/2 md:mb-0">
                    <div
                        class="w-full h-96 bg-cover bg-no-repeat bg-center rounded-2xl overflow-hidden"
                        :class="backgroundSelected"
                    >
                        <swiper
                            :a11y="{
                                enabled: true,
                                prevSlideMessage: 'Anterior',
                                nextSlideMessage: 'Siguiente',
                            }"
                            :centeredSlides="false"
                            :slidesPerView="1"
                            :grabCursor="true"
                            :loop="true"
                            :navigation="true"
                            :modules="modules"
                            class="swiperProducts h-96"
                        >
                            <swiper-slide class="w-full h-96">
                                <img
                                    class="w-full h-full p-4 object-contain"
                                    :src="product.image"
                                    :alt="product.name"
                                />
                            </swiper-slide>
                            <swiper-slide class="w-full h-96" v-for="(image, index) in product.images" :key="index">
                                <img
                                    class="w-full h-full p-4 object-contain"
                                    :src="`/storage/products/${image.image}`"
                                    :alt="product.name"
                                />
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
                <div class="w-full flex flex-col justify-center items-start md:w-1/2 md:flex-row">
                    <div class="w-full space-y-4">
                        <h1 class="text-orange text-3xl leading-9 font-bold pr-2 pb-2">
                            {{ product.name }}
                        </h1>
                        <div
                            v-if="product.special_edition"
                            class="bg-red text-white w-40 text-center py-1 rounded text-md font-bold text-sm"
                        >
                            Edición Limitada
                        </div>
                        <div class="content-list font-helvetica" v-html="product.description"></div>
                        <div v-if="product.nutrition_table" class="bg-lightblue rounded-lg overflow-hidden">
                            <button
                                @click="showNutritionTable = !showNutritionTable"
                                :aria-expanded="showNutritionTable"
                                aria-label="Tabla nutrimental"
                                class="h-10 px-4 flex justify-between items-center w-full"
                            >
                                <span>Tabla Nutrimental</span>
                                <font-awesome-icon
                                    v-show="!showNutritionTable"
                                    icon="fa-regular fa-plus"
                                    class="text-lg"
                                />
                                <font-awesome-icon
                                    v-show="showNutritionTable"
                                    icon="fa-regular fa-minus"
                                    class="text-lg"
                                />
                            </button>
                            <div v-show="showNutritionTable" class="bg-[#0649a1] p-4 font-helvetica">
                                <table class="w-full max-w-lg mx-auto table-auto border border-white text-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col" colspan="3" class="text-lg text-center">
                                                <strong>Declaración Nutrimental</strong>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in nutrimentalTable" class="border border-white">
                                            <template v-for="(text, index2) in row">
                                                <th
                                                    v-if="index2 === 0"
                                                    class="border border-white px-1"
                                                    scope="row"
                                                    :class="[
                                                        index2 > 0 ? 'text-center' : '',
                                                        index == 0 ? 'font-bold' : '',
                                                    ]"
                                                    v-html="text"
                                                />
                                                <td
                                                    v-else
                                                    class="border border-white px-1"
                                                    :class="[
                                                        index2 > 0 ? 'text-center' : '',
                                                        index == 0 ? 'font-bold' : '',
                                                    ]"
                                                    v-html="text"
                                                />
                                            </template>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-center">
                                                <strong>Contenido Energético por envase (*** g): ***kcal(***kJ)</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div v-if="product.ingredients" class="bg-lightblue rounded-lg overflow-hidden">
                            <button
                                @click="showIngredients = !showIngredients"
                                :aria-expanded="showIngredients"
                                aria-label="Ingredientes"
                                class="h-10 px-4 flex justify-between items-center w-full"
                            >
                                <span class=""> Ingredientes </span>
                                <font-awesome-icon
                                    v-show="!showIngredients"
                                    icon="fa-regular fa-plus"
                                    class="text-lg"
                                />
                                <font-awesome-icon
                                    v-show="showIngredients"
                                    icon="fa-regular fa-minus"
                                    class="text-lg"
                                />
                            </button>
                            <div
                                v-show="showIngredients"
                                class="bg-[#0649a1] p-4 font-helvetica text-sm"
                                v-html="product.ingredients"
                            ></div>
                        </div>
                        <Link
                            href="/donde-comprar"
                            target="_blank"
                            class="font-bold bg-white text-blue rounded-md w-60 h-10 flex justify-center items-center transition-all hover:bg-opacity-80"
                        >
                            Comprar
                        </Link>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full bg-recipesRelated bg-cover">
            <div class="container my-16">
                <h2 class="text-orange font-bold text-3xl text-center mt-8 md:text-4xl mb-8">Recetas Relacionadas</h2>
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-5xl mx-auto">
                    <article
                        v-for="(related_recipe, index) in related_recipes"
                        :key="index"
                        v-if="related_recipes.length"
                        class="w-full rounded-2xl overflow-hidden"
                    >
                        <div class="w-full h-52 flex justify-center items-center">
                            <img
                                class="w-full h-full object-cover bg-center"

                                :src="`/storage/recipes/${related_recipe.thumbnail}`"
                                :alt="related_recipe.name"
                            />
                        </div>
                        <div class="bg-pink w-full h-32 space-y-2 p-4 flex flex-col justify-between items-start">
                            <p class="text-sm md:text-base">
                                {{ related_recipe.name }}
                            </p>
                            <div class="w-full flex justify-between items-center space-x-1">
                                <span class="text-[14px]">
                                    {{ related_recipe.difficulty }}
                                </span>
                                <!-- <span class="text-[14px]">10 min</span> -->
                                <span class="text-[14px]">{{ related_recipe.portions }} </span>
                                <Link :href="related_recipe.url" class="text-sm btn-white shrink-0">Ver Receta </Link>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination, A11y } from "swiper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
    name: "Show",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: ["product", "related_recipes"],
    data() {
        return {
            modules: [Navigation, Pagination, A11y],
            showNutritionTable: false,
            showIngredients: false,
            backgroundSelected: null,
        };
    },
    computed: {
        nutrimentalTable() {
            return JSON.parse(this.product.nutrition_table).data;
        },
    },
    mounted() {
        var backgrounds = [
            "bg-blueCircles2",
            "bg-skyblueCircles",
            "bg-redCircles",
            "bg-yellowCircles",
            "bg-blueCircles",
            "bg-purpleCircles",
            "bg-skyblueCircles2",
        ];
        this.backgroundSelected = backgrounds[Math.floor(Math.random() * backgrounds.length)];
    },
    methods: {
        generateUrl(recipe) {
            if (recipe?.thumbnail) {
                return `${this.$page.props.baseUrl}/storage/recipes/${recipe.thumbnail}`;
            }
            return `https://img.youtube.com/vi/${recipe.video_url}/mqdefault.jpg`;
        },
    },
};
</script>
<style>
.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
}

.swiper-pagination-bullet-active {
    background: theme("colors.white");
}

.swiper-button-prev {
    left: 0px;
    right: auto;
    background-color: #fff;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.swiper-button-prev:after {
    font-size: 1.5rem;
    color: theme("colors.blue");
}

.swiper-button-next {
    right: 0px;
    left: auto;
    background-color: #fff;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.swiper-button-next:after {
    font-size: 1.5rem;
    color: theme("colors.blue");
}

/* swiperSlider */
.swiperSlider .swiper-button-prev {
    left: 2rem;
}

.swiperSlider .swiper-button-next {
    right: 2rem;
}

@media (max-width: 640px) {
    .swiper-button-prev,
    .swiper-button-next {
        width: 2.4rem;
        height: 2.4rem;
    }

    .swiperSlider .swiper-button-prev {
        left: 0.5rem;
    }

    .swiperSlider .swiper-button-next {
        right: 0.5rem;
    }
}

.swiper-button-lock {
    display: none !important;
}
</style>
